var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheched(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.21981 0.469811L3.50006 5.18956L1.78031 3.46981C1.48603 3.18558 1.01825 3.18965 0.728947 3.47895C0.439647 3.76825 0.435582 4.23603 0.719811 4.53031L2.96981 6.78031C3.26269 7.0731 3.73744 7.0731 4.03031 6.78031L9.28031 1.53031C9.56454 1.23603 9.56047 0.768248 9.27117 0.478947C8.98187 0.189647 8.5141 0.185582 8.21981 0.469811Z",
    fill: "#27AE60"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheched);
export default __webpack_public_path__ + "static/media/cheched.e3e93c5b.svg";
export { ForwardRef as ReactComponent };